/* NOORE — motion system.
   Deferred, and deliberately inert around commerce: it only ever toggles
   opacity/transform on elements that opt in with data-noore-reveal. It never
   touches the product form, the variant picker or the cart, so it cannot
   delay or block add-to-cart. */
(function () {
  var root = document.documentElement;

  // The head script already decided whether motion is on; trust that flag so
  // the two can never disagree.
  if (!root.classList.contains('noore-motion-ready')) return; // page stays as rendered

  function reveal(el) {
    el.classList.add('is-in');
    var group = el.hasAttribute('data-noore-reveal-group') ? el : null;
    if (group) {
      // children inherit the reveal; the CSS supplies their stagger
      for (var i = 0; i < group.children.length; i++) group.children[i].classList.add('is-in');
    }
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      reveal(e.target);
      io.unobserve(e.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  function observe(scope) {
    (scope || document).querySelectorAll('[data-noore-reveal]').forEach(function (el) {
      if (el.dataset.nooreObserved) return;
      el.dataset.nooreObserved = '1';
      // Anything already on screen at load reveals on the next frame rather
      // than snapping, so the first paint still animates.
      io.observe(el);
    });
  }

  // Let the browser paint the hidden state first. Without this, elements that
  // are already on screen get their reveal in the same frame they are hidden,
  // the transition never starts, and everything above the fold simply snaps.
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { observe(document); });
  });

  // Theme editor re-renders sections; pick up anything new.
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();
